<template>
  <div class="resume-list-page">
    <div class="resume-list-page__head">
      <h1 class="resume-list-page__title">{{$tResumeList('Resume')}}</h1>
      <div class="resume-list-page__head-buttons">
        <button type="button" class="base-btn base-btn--outline-grey">
          <BaseSvg name="ico-push-pull" width="1.4rem" height="1.4rem"/>
          <span class="base-btn__text">{{$tResumeList('Import resume')}}</span>
        </button>
        <button type="button" class="base-btn base-btn--green">
          <BaseSvg name="ico-plus" width="1.3rem" height="1.3rem"/>
          <span class="base-btn__text">{{$tResumeList('Add resume')}}</span>
        </button>
      </div>
    </div>

    <div class="resume-list-page__tabs account-tabs _grey">
      <div class="account-tabs__navs d-sm-none">
        <AccountTabsNavs
          class="account-tabs__navs-inner"
          :tabs="tabs"
          :current="currentTab"
          @change="currentTab = $event"
        />
      </div>
      <AccountTabsNavsMob
        :tabs="tabs"
        :current="currentTab"
        @change="currentTab = $event"
      />

      <div class="account-tabs__content">
        <transition
          name="fade"
          mode="out-in"
        >
          <div v-if="currentTab === 0"
               class="account-tabs__block"
               :key="1">
            <ResumeTabItemMy :is-mob="isMob"/>
          </div>
          <div v-if="currentTab === 1"
               class="account-tabs__block"
               :key="2">
            <ResumeTabItemBase :is-mob="isMob" :full="false"/>
          </div>
          <div v-if="currentTab === 2"
               class="account-tabs__block"
               :key="3">
            <ResumeTabItemReg :is-mob="isMob" :full="true"/>
          </div>
        </transition>
      </div>
    </div>

  </div>
</template>

<script>
  import AccountTabsNavs from '@/components/accountTabs/AccountTabsNavs'
  import AccountTabsNavsMob from '@/components/accountTabs/AccountTabsNavsMob'
  import ResumeTabItemMy from '@/components/resumeList/ResumeTabItemMy'
  import ResumeTabItemBase from '@/components/resumeList/ResumeTabItemBase'
  import ResumeTabItemReg from '@/components/resumeList/ResumeTabItemReg'
  import windowSizeMixin from '@/mixins/windowSizeMixin'

  export default {
    name: 'AccountResumeListPage',
    mixins: [windowSizeMixin],
    components: {
      ResumeTabItemReg,
      ResumeTabItemBase,
      ResumeTabItemMy,
      AccountTabsNavs,
      AccountTabsNavsMob
    },
    data() {
      return {
        currentTab: 1,
        tabs: [
          {name: `${this.$tResumeList('My resume')}`},
          {name: `${this.$tResumeList('CV Database')} (259)`},
          {name: `${this.$tResumeList('In the processing')} (3)`}
        ]
      }
    },
    computed: {
      isMob() {
        return this.windowSizeMixin.width < 1024
      }
    }
  }
</script>

<style>

</style>
